// Shared vertex-color baking helpers. Several systems merge many small colored
// boxes into ONE vertex-colored geometry drawn with a single Lambert material
// (the instanced-prop / Word-Oxen trick) — these two bakers are that shared
// primitive, so the gradient math lives in exactly one place.
import * as THREE from 'three';

// Build one flat-colored box: BoxGeometry → optional X-rotation → translate →
// bakeColor. The "merge many small colored boxes into one vertex-colored
// geometry" systems (chunk prop factories, the Word Oxen) all repeat this exact
// idiom, so it lives here next to bakeColor as the single source.
export function coloredBox(w, h, d, x, y, z, hex, rx = 0) {
  const g = new THREE.BoxGeometry(w, h, d);
  if (rx) g.rotateX(rx);
  g.translate(x, y, z);
  return bakeColor(g, hex);
}

// Bake a single flat color into every vertex of a geometry.
export function bakeColor(geo, hex) {
  const c = new THREE.Color(hex);
  const n = geo.attributes.position.count;
  const colors = new Float32Array(n * 3);
  for (let i = 0; i < n; i++) { colors[i * 3] = c.r; colors[i * 3 + 1] = c.g; colors[i * 3 + 2] = c.b; }
  geo.setAttribute('color', new THREE.BufferAttribute(colors, 3));
  return geo;
}

// Bake a bottom→top vertical gradient across a geometry's Y extent.
export function tintVertexRange(geo, bottomHex, topHex) {
  const pos = geo.attributes.position;
  const bottom = new THREE.Color(bottomHex), top = new THREE.Color(topHex), tmp = new THREE.Color();
  let minY = Infinity, maxY = -Infinity;
  for (let i = 0; i < pos.count; i++) {
    const y = pos.getY(i);
    if (y < minY) minY = y;
    if (y > maxY) maxY = y;
  }
  const span = Math.max(0.0001, maxY - minY);
  const colors = new Float32Array(pos.count * 3);
  for (let i = 0; i < pos.count; i++) {
    tmp.copy(bottom).lerp(top, (pos.getY(i) - minY) / span);
    colors[i * 3] = tmp.r; colors[i * 3 + 1] = tmp.g; colors[i * 3 + 2] = tmp.b;
  }
  geo.setAttribute('color', new THREE.BufferAttribute(colors, 3));
  return geo;
}
